
(() => {
  if (window.troopManualGift) return;

  window.troopGiftHasOtherAutomaticDiscount = function (cart) {
    const items = Array.isArray(cart?.items) ? cart.items : [];
    const rules = [
      ...(Array.isArray(window.freeGiftRules) ? window.freeGiftRules : []),
      ...(Array.isArray(window.nonFreeGiftRules) ? window.nonFreeGiftRules : [])
    ];
    const giftVariantIds = new Set(rules.map(rule => Number(rule.freeGiftVariantId)).filter(Boolean));
    const isGiftLine = item => {
      const properties = item.properties || {};
      return properties._is_free_gift === 'true' ||
        Boolean(properties._auto_free_gift_rule) ||
        properties._troop_manual_gift === 'true' ||

        (giftVariantIds.has(Number(item.variant_id)) && Number(item.final_line_price) === 0);
    };
    const gifts = items.filter(isGiftLine);
    const regularItems = items.filter(item => !isGiftLine(item));
    const allocations = item => [
      ...(Array.isArray(item.line_level_discount_allocations) ? item.line_level_discount_allocations : []),
      ...(Array.isArray(item.discount_allocations) ? item.discount_allocations : [])
    ];
    const isCode = application => {
      const type = String(application?.type || '').toLowerCase();
      return type === 'discount_code' || type === 'code';
    };
    const amount = value => Math.max(0, Number(value) || 0); 

    const hasOtherLineDiscount = item => {
      const applied = allocations(item).filter(a => amount(a.amount) > 0);
      if (applied.some(a => !isCode(a.discount_application))) return true;
      const identifiedCodeDiscount = applied.reduce((sum, a) => sum + amount(a.amount), 0);
      const fallbackDiscount = Math.max(
        amount(item.line_level_total_discount),
        amount(item.total_discount),
        (Array.isArray(item.discounts) ? item.discounts : []).reduce((sum, d) => sum + amount(d.amount), 0),
        amount(Number(item.original_line_price) - Number(item.final_line_price))
      );

      return fallbackDiscount > identifiedCodeDiscount;
    };

    if (regularItems.some(hasOtherLineDiscount)) return true;

    for (const application of cart?.cart_level_discount_applications || []) {
      if (isCode(application) || amount(application?.total_allocated_amount) <= 0) continue;
      const hasApplication = item =>
        (item.discounts || []).some(discount =>
          discount.title === application.title && amount(discount.amount) > 0
        ) || allocations(item).some(allocation => {
          const applied = allocation.discount_application;
          return amount(allocation.amount) > 0 && applied &&
            ((application.key && applied.key && application.key === applied.key) ||
             (application.title && applied.title === application.title));
        });

      if (regularItems.some(hasApplication)) return true;
      if (!gifts.some(hasApplication)) return true;
    }
    return false;
  };
  class TroopManualGift {
    constructor() {
      this.timer = null;
      this.running = false;
      this.pending = false;
      this.adding = false;
      this.lastCount = null;
      this.start();
    }
    root() { return window.Shopify?.routes?.root || '/'; }
    async cart() {
      const response = await fetch(`${this.root()}cart.js`, { headers: { Accept: 'application/json' }, cache: 'no-store' });
      if (!response.ok) throw new Error('Unable to retrieve cart');
      return response.json();
    }
    get rules() { return Array.isArray(window.nonFreeGiftRules) ? window.nonFreeGiftRules : []; }
    validDate(card) {
      const now = new Date();
      for (const [value, isEnd] of [[card.dataset.freeGiftStart, false], [card.dataset.freeGiftEnd, true]]) {
        if (!value) continue;
        const date = /^\d{4}-\d{2}-\d{2}$/.test(value) ? new Date(`${value}T${isEnd ? '23:59:59' : '00:00:00'}`) : new Date(value);
        if (Number.isNaN(date.getTime()) || (isEnd ? now > date : now < date)) return false;
      }
      return true;
    }
    hasManualGift(cart) {
      const ids = new Set(this.rules.filter(rule => rule.enabled && Number(rule.freeGiftVariantId)).map(rule => Number(rule.freeGiftVariantId)));
      document.querySelectorAll('[data-free-gift-card]').forEach(card => {
        const id = Number(card.dataset.freeGiftVariant);
        if (id) ids.add(id);
      });
      return cart.items.some(item => ids.has(Number(item.variant_id)));
    }
    eligible(card, cart) {
      const id = Number(card.dataset.freeGiftVariant);
      if (!id || !this.validDate(card) || cart.items.some(item => Number(item.variant_id) === id)) return false;
      const condition = card.dataset.freeGiftCondition;
      const rule = this.rules.find(rule => Number(rule.freeGiftVariantId) === id && rule.enabled);
      if (!rule) return false;
      if (condition === 'price') {
        const threshold = Number(rule.freeGiftPrice);
        const total = cart.items.reduce((sum, item) => sum + (
          item.properties?._is_free_gift === 'true' ||
          item.properties?._troop_manual_gift === 'true' ||
          item.properties?._auto_free_gift_rule ? 0 : Number(item.final_line_price ?? 0)
        ), 0);
        return threshold > 0 && total >= threshold;
      }
      if (condition === 'collection') {
        const ids = (rule.eligibleProductIds || []).map(Number);
        return ids.length > 0 && cart.items.some(item => ids.includes(Number(item.product_id)));
      }
      return false;
    }
    render(cart) {
      const giftAdded = this.hasManualGift(cart);
      const blockedByAnotherDiscount = window.troopGiftHasOtherAutomaticDiscount(cart);
      document.querySelectorAll('[data-manual-gifts-wrapper]').forEach(wrapper => {
        let visible = false;
        wrapper.querySelectorAll('[data-free-gift-card]').forEach(card => {
          const show = !blockedByAnotherDiscount && !giftAdded && this.eligible(card, cart);
          card.hidden = !show;
          if (show) visible = true;
        });
        wrapper.hidden = blockedByAnotherDiscount || giftAdded || !visible || cart.item_count === 0;
      });
    }
    async sync() {
      if (this.running) { this.pending = true; return; }
      this.running = true;
      try {
        let cart = await this.cart();
        if (window.troopGiftHasOtherAutomaticDiscount(cart)) {

          for (const item of cart.items.filter(item => item.properties?._troop_manual_gift === 'true')) {
            const response = await fetch(`${this.root()}cart/change.js`, {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
              body: JSON.stringify({ id: item.key, quantity: 0 })
            });
            if (!response.ok) throw new Error('Unable to remove incompatible manual gift');
            cart = await this.cart();
            this.refresh();
          }
        }
        this.render(cart);
      } catch (error) { console.error('[MANUAL GIFT] Sync failed', error); }
      finally {
        this.running = false;
        if (this.pending) { this.pending = false; this.schedule(); }
      }
    }
    schedule() {
      clearTimeout(this.timer);
      this.timer = setTimeout(() => { this.timer = null; this.sync(); }, 180);
    }
    refresh() {
      if (typeof window.trigger === 'function') window.trigger('theme:cart:refresh');
      else window.dispatchEvent(new Event('theme:cart:refresh'));
      this.schedule();
    }
    async add(button) {
      if (this.adding || button.disabled) return;
      const card = button.closest('[data-free-gift-card]');
      if (!card) return;
      this.adding = true;
      button.disabled = true;
      button.classList.add('loading');
      try {
        const cart = await this.cart();
        if (window.troopGiftHasOtherAutomaticDiscount(cart) || this.hasManualGift(cart) || !this.eligible(card, cart)) {
          this.render(cart);
          return;
        }
        const variantId = Number(card.dataset.freeGiftVariant);
        const response = await fetch(`${this.root()}cart/add.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: variantId, quantity: 1, properties: { _troop_manual_gift: 'true' } }] })
        });
        const result = await response.json();
        if (!response.ok) throw new Error(result.description || result.message || 'Unable to add gift');
        console.log('[MANUAL GIFT] Product added', variantId);
        this.render(await this.cart());

        this.refresh();
      } catch (error) { console.error('[MANUAL GIFT] Add failed', error); }
      finally {
        this.adding = false;
        if (button.isConnected) { button.disabled = false; button.classList.remove('loading'); }
      }
    }
    start() {
      document.addEventListener('click', event => {
        const button = event.target.closest('[data-add-free-gift]');
        if (!button) return;
        event.preventDefault();
        event.stopPropagation();
        this.add(button);
      }, true);
      const startObserver = () => {
        this.observer = new MutationObserver(records => {
          if (records.some(record => [...record.addedNodes].some(node => node.nodeType === 1 && (node.matches?.('[data-manual-gifts-wrapper], .cart--item, cart-element') || node.querySelector?.('[data-manual-gifts-wrapper], .cart--item'))))) this.schedule();
        });
        this.observer.observe(document.body, { subtree: true, childList: true });
        this.schedule();
      };
      if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', startObserver, { once: true });
      else startObserver();
      document.addEventListener('troop:gift:changed', () => this.schedule());
      window.addEventListener('theme:cart:refresh', () => this.schedule());
      window.addEventListener('pageshow', event => { if (event.persisted) this.schedule(); });
      const original = window.fetch;
      window.fetch = (...args) => {
        const promise = original.apply(window, args);
        const raw = typeof args[0] === 'string' ? args[0] : args[0]?.url;
        const method = String(args[1]?.method || args[0]?.method || 'GET').toUpperCase();
        if (raw && method !== 'GET' && /\/cart\/(add|change|update|clear)(\.js)?\/?$/.test(new URL(raw, location.href).pathname)) promise.then(response => { if (response.ok) this.schedule(); }).catch(() => {});
        return promise;
      };
    }
  }
  window.troopManualGift = new TroopManualGift();
})();
